import React from 'react'

import { Button } from '@plurall/elo-beta'

interface IMobileButton {
  onClick?: () => void
}
const MobileButton = ({ onClick }: IMobileButton) => (
  <Button icon='Plus' secondary onClick={onClick} />
)

export default MobileButton
